import React from 'react'
import { Link } from 'react-router-dom'
import Logo from '../../images/logoj.png'
import Products from '../../api/products';


const ClickHandler = () => {
    window.scrollTo(10, 0);
}
const SubmitHandler = (e) => {
    e.preventDefault()
}

const Footer = (props) => {
    return (
        <footer className="wpo-site-footer">
            <div className="wpo-upper-footer">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                            <div className="widget about-widget">
                                <div className="logo widget-title">
                                    <img src={Logo} alt="blog" style={{width: '220px', height: 'auto'}} />
                                </div>
                                <p>Jagruti Chemicals provides reliable, high-quality chemical solutions for diverse industries.</p>
                                {/* <ul>
                                    <li>
                                        <Link onClick={ClickHandler} to="/">
                                            <i className="ti-facebook"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={ClickHandler} to="/">
                                            <i className="ti-twitter-alt"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={ClickHandler} to="/">
                                            <i className="ti-instagram"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={ClickHandler} to="/">
                                            <i className="ti-google"></i>
                                        </Link>
                                    </li>
                                </ul> */}
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>Useful Links</h3>
                                </div>
                                <ul>
                                    <li><Link onClick={ClickHandler} to="/about">About Us</Link></li>
                                    <li><Link onClick={ClickHandler} to="/about#mission-vision">Mission & Vision</Link></li>
                                    <li><Link onClick={ClickHandler} to="/about#certificates">Certificates</Link></li>
                                    <li><Link onClick={ClickHandler} to="/industries">Industries</Link></li>
                                    <li><Link onClick={ClickHandler} to="/contact">Contact Us</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>Products </h3>
                                </div>
                                <ul>
                                    {Products.slice(0, 5).map((product, idx) => (
                                        <li key={idx}><Link onClick={ClickHandler} to={`/products/${product.slug}`}>{product.name}</Link></li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                            <div className="widget wpo-service-link-widget">
                                <div className="widget-title">
                                    <h3>Contact</h3>
                                </div>
                                <div className="contact-ft">
                                    <ul>
                                        <li><i className="fi flaticon-location"></i>Gala no. 3, First Floor, Mahavir Nagar, Dungra, Vapi - 396 193, Valsad, Gujarat</li>
                                        <li><i className="fi flaticon-phone-call"></i><a href="tel:+917435981782">+91 7435981782</a></li>
                                        <li><i className="fi flaticon-send"></i><a href="mailto:jagrutichem@yahoo.com">jagrutichem@yahoo.com</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="wpo-lower-footer">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-lg-3 mb-2 mb-lg-0">
                            <p className="copyright mb-0">
                                Made with <span style={{color: '#4CAF50'}}>&#10084;</span> by
                                <a title="Enlightened Digital : website designing company in vapi, software company in vapi, digital marketing company in vapi" target="_blank" rel="noopener noreferrer" href="https://www.enlighteneddigital.in/">
                                    <img height="21px" width="90" src="/images/enlogo.gif" alt="logo" style={{ marginLeft: '5px' }} />
                                </a>
                            </p>
                        </div>
                        <div className="col col-xs-12 col-lg-9 text-lg-end">
                            <p className="copyright"> Copyright &copy; 2025 Jagruti Chemicals. All Rights Reserved.</p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;